export interface Clipboard {
  writeText(text: string): Promise<void>
}

function writeWithNavigator(text: string): Promise<boolean> {
  const navigatorLike = (globalThis as { navigator?: Navigator }).navigator
  const api = navigatorLike?.clipboard
  if (!api || typeof api.writeText !== 'function') return Promise.resolve(false)
  return api.writeText(text).then(
    () => true,
    () => false,
  )
}

function writeWithExecCommand(text: string): void {
  const doc = (globalThis as { document?: Document }).document
  if (!doc?.body) throw new Error('当前环境不支持复制')
  const textarea = doc.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.top = '-1000px'
  textarea.style.opacity = '0'
  doc.body.appendChild(textarea)
  try {
    textarea.select()
    if (!doc.execCommand('copy')) throw new Error('复制被浏览器拒绝')
  } finally {
    textarea.remove()
  }
}

/** navigator.clipboard 优先；不可用时降级为 textarea + document.execCommand('copy') */
export const clipboard: Clipboard = {
  writeText: async (text) => {
    if (await writeWithNavigator(text)) return
    writeWithExecCommand(text)
  },
}
